// スクロールしない画面の共通部品：キャラ切替（◀ 顔 ▶＋スワイプ）、左右スワイプの検出。
import '../styles/screens/fit.css';
import { CHAR_IDS, type CharId } from '@hyakki/core';

export const stepChar = (cur: CharId, d: number): CharId => CHAR_IDS[(CHAR_IDS.indexOf(cur) + d + CHAR_IDS.length) % CHAR_IDS.length];

/** root の中の selector の要素で左右スワイプしたら fn(-1|1)。戻り値で解除 */
export function onSwipe(root: HTMLElement, selector: string, fn: (dir: -1 | 1, el: HTMLElement) => void) {
  let sx = 0;
  let sy = 0;
  let target: HTMLElement | null = null;
  const down = (e: PointerEvent) => {
    target = (e.target as HTMLElement).closest<HTMLElement>(selector);
    sx = e.clientX;
    sy = e.clientY;
  };
  const up = (e: PointerEvent) => {
    if (!target) return;
    const dx = e.clientX - sx;
    const dy = e.clientY - sy;
    const t = target;
    target = null;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) fn(dx < 0 ? 1 : -1, t);
  };
  root.addEventListener('pointerdown', down);
  root.addEventListener('pointerup', up);
  return () => {
    root.removeEventListener('pointerdown', down);
    root.removeEventListener('pointerup', up);
  };
}
